export const normalizePhoneNumber = (phone?: string | null): string => {
  if (!phone) return '';

  // "+82 10-8081-8109" -> "010-8081-8109" 국내 표기로 변환 후 숫자만 추출
  const digits = phone.replace(/^\+82\s?/, '0').replace(/[^0-9]/g, '');

  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return digits;
};
